import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
export type QuickAccessItem = {
  to: string;
  label: string;
  detail: string;
  icon: React.ComponentType<{
    className?: string;
  }>;
  /** Tint class pair for the icon container. */
  tone: string;
};

/**
 * Icon-first card. The tile colour carries the domain, so six destinations stay
 * distinguishable at a glance without six different card treatments.
 */
export function QuickAccessCard({
  item
}: {
  item: QuickAccessItem;
}) {
  const Icon = item.icon;
  return <Link to={item.to} className="group flex h-full flex-col rounded-card border border-line bg-surface px-4 py-4 shadow-[0_1px_2px_rgba(15,23,42,0.04)] transition-[transform,box-shadow,border-color] duration-200 ease-out hover:-translate-y-0.5 hover:border-line-strong hover:shadow-[0_8px_24px_rgba(15,23,42,0.07)]" data-id="element-1073" data-mp="1m8e0txeah1bp">
      <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${item.tone}`} data-id="element-1074" data-mp="xdzwpxgaz47">
        <Icon aria-hidden className="h-5 w-5" data-id="element-1075" data-mp="3ey80we8aoexr" />
      </span>
      <span className="mt-3.5 block text-body font-semibold text-ink" data-id="element-1076" data-mp="3eyq2lqdq7ld2">{item.label}</span>
      <span className="mt-1 block text-caption leading-5 text-ink-muted" data-id="element-1077" data-mp="3jwjacnuognfg">{item.detail}</span>
      <span className="mt-auto flex justify-end pt-3" data-id="element-1078" data-mp="34yzblyodjohq">
        <ArrowRightIcon aria-hidden className="h-4 w-4 text-ink-subtle transition-transform duration-150 ease-out group-hover:translate-x-1 group-hover:text-brand-700" data-id="element-1079" data-mp="39ylmw2kn6unw" />
      </span>
    </Link>;
}